import { combineReducers } from "redux";

import apartments from "./apartments";
import services from "./services";
import account from "./account";

export default combineReducers({
  apartments,
  services,
  account
});
